<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn class="success" v-on="on">
        <v-icon left>person_add</v-icon>
        Add User
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <v-icon left>person_add</v-icon>
        <span class="headline">Add New User</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon large color="error">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container grid-list-md class="py-0">
        <v-card-text class="py-0">
          <v-form ref="add_user_form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newUser.name"
              label="Name *"
              :rules="[(v) => !!v || 'Name is required']"
            ></v-text-field>
            <v-text-field
              v-model="newUser.email"
              label="Email *"
              :rules="[
                (v) => !!v || 'Email is required',
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid',
              ]"
            ></v-text-field>
            <v-text-field
              name="new-password"
              v-model="newUser.password"
              label="Password *"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :rules="[
                (v) => !!v || 'Password is required',
                (v) =>
                  /(?=.{6,}).*$/.test(v) ||
                  'Password must be minimum 6 characters',
              ]"
            ></v-text-field>
            <v-text-field
              name="confirm-password"
              label="Comfirm Password *"
              :rules="[
                newUser.password === newUser.confirmPassword ||
                  'Passwords must match',
              ]"
              :append-icon="
                showPasswordConfirm ? 'visibility' : 'visibility_off'
              "
              :type="showPasswordConfirm ? 'text' : 'password'"
              @click:append="showPasswordConfirm = !showPasswordConfirm"
              v-model="newUser.confirmPassword"
            ></v-text-field>
            <v-autocomplete
              v-model="newUser.admin_type"
              :items="userTypes"
              label="User Type"
              item-text="name"
              item-value="id"
              persistent-hint
              :rules="[(v) => !!v || 'User Type is required']"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            :loading="loading"
            :disabled="loading || !valid"
            @click="save"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from "../../api/datadash";
  import { mapState } from "vuex";
  export default {
    props: ["userTypes"],
    data() {
      return {
        dialog: false,
        loading: false,
        valid: false,
        showPassword: false,
        showPasswordConfirm: false,
        newUser: {
          name: "",
          email: "",
          password: "",
          password_confirmation: "",
          admin_type: null,
        },
        defaultItem: {
          name: "",
          email: "",
          password: "",
          password_confirmation: "",
          admin_type: null,
        },
      };
    },
    computed: {
      ...mapState(["auth"]),
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    methods: {
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.newUser = Object.assign({}, this.defaultItem);
        }, 100);
      },
      async save() {
        await this.$refs.add_user_form.validate();
        if (this.valid) {
          try {
            this.loading = true;

            const { data } = await api.storeData(
              this.auth.token,
              "official-user",
              this.newUser
            );

            if (data.error) {
              this.$emit("result", [data.errorMsg, "error"]);
            } else {
              this.$emit("result", ["User created successfully", "success"]);
              this.close();
            }

            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        }
      },
    },
  };
</script>
